import React, { Component } from 'react';
import './Footer.css'


class Overview extends Component {
    render() {

        return (
            <div>
                <footer className="text-white" id="foot">
                    <div className="container-fluid">
                        <div className="row text-center box-inner px-4 pt-4 pb-2">
                            <a className="col-md-3 col-sm-6 text-muted" href="#root">© Perkypandas.club 2021</a>
                            <div className="col text-center"><p className=" text-center">
                                <a className="text-mint" href="http://twitter.com/perkypandasclub" target="_blank" rel="noopener noreferrer">@perkypandasclub</a> {"designed with "} <i className="text-danger fa fa-heart" aria-hidden="true"></i> {" by"} <a className="text-mint" href="https://twitter.com/thejnbtc" target="_blank" rel="noopener noreferrer">@thejnbtc</a>
                            </p></div>
                            <div className="col-md-3 col-sm-6 mb-2">
                                <section>
                                    <a className="btn btn-outline-light btn-floating mx-2" href="#!" role="button" target="_blank" rel="noopener noreferrer"><i className="fab fa-discord"></i
                                    ></a>

                                    <a className="btn btn-outline-light btn-floating mx-2" href="#!" role="button" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i
                                    ></a>

                                    <a className="btn btn-outline-light btn-floating mx-2" href="mailto: info@perkypandas.club" role="button"><i className="fa fa-envelope"></i
                                    ></a>

                                    <a className="btn btn-outline-light btn-floating mx-2" href="https://etherscan.io/" role="button" target="_blank" rel="noopener noreferrer"><i className="fab fa-ethereum"></i
                                    ></a>

                                </section>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        );
    }
}

export default Overview;
